// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__wTdOm","mainContainer":"layout_mainContainer__NMevC"};